var lorem = {};
module['exports'] = lorem;
lorem.words = require("./words");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/de/lorem/index.js
 ** module id = 340
 ** module chunks = 0
 **/